import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import PageDetail from './pages/PageDetail'
import Medarbejdere from './pages/Medarbejdere'
import Referencer from './pages/Referencer'
import Udtalelser from './pages/Udtalelser'
import Kontakt from './pages/Kontakt'

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-800 antialiased selection:bg-blue-500 selection:text-white">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          {/* General Pages */}
          <Route path="/" element={<PageDetail slug="index" />} />
          <Route path="/bliv-vikar" element={<PageDetail slug="bliv-vikar" />} />
          <Route path="/privatlivspolitik" element={<PageDetail slug="privatlivspolitik" />} />
          <Route path="/hvad-tilbyder-vi" element={<PageDetail slug="hvad-tilbyder-vi" />} />
          <Route path="/mission-vision-og-vaerdier" element={<PageDetail slug="mission-vision-og-vaerdier" />} />
          
          {/* Special Pages */}
          <Route path="/medarbejdere" element={<Medarbejdere />} />
          <Route path="/referencer" element={<Referencer />} />
          <Route path="/udtalelser-fra-vikarer" element={<Udtalelser />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* Fallback 404 */}
          <Route path="*" element={<PageDetail slug="404" />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
